export function afaCodeMask(value = '', defaultEmptyReturn = '') {
  if (!value) return defaultEmptyReturn

  return value
    .replace(/[oO]/g, '0')      // substitui O ou o por 0
    .replace(/[^a-zA-Z0-9]/g, '') // mantém apenas letras e números
    .slice(0, 8)                 // limita a no máximo 8 caracteres
}
